import { Injectable } from '@angular/core';
import { BaseNotifier } from '../../shared/notifiers/base-notifier';
import { Ref } from '../../shared/providers/ref';
import { ViewMode } from '../../shared/enums/view-mode.enum';
import { ViewModeState } from '../states/view-mode-state';

@Injectable({ providedIn: 'root' })
export class ViewModeNotifier extends BaseNotifier<ViewModeState> {
  constructor(ref: Ref) {
    super(ref, { mode: ViewMode.Map });
  }

  toggleMode(): void {
    const current = this.getStateValue().mode;
    this.setState({ mode: current === ViewMode.Map ? ViewMode.Scene : ViewMode.Map });
  }

  setMode(mode: ViewMode): void {
    this.setState({ mode });
  }
}
